module.exports = __webpack_public_path__ + "media/images/bg/blank-cyan-8d2130740b1c25bb401549aba4a71201.svg";